import "./popup/popup.scss";

require("./gallery.js");

import "../../gallery/widget.scss";
import "./gallery/gallery.scss";
